<template>
  <div class="home">
    <div class="page-head">
      <router-link to="/" class="logo-container">
        <img src="~@/assets/img/img_logo.svg" alt="logo" />
      </router-link>

      <p class="txt">为商业流向直连设计</p>
      <ul class="func-list">
        <li>
          <a href="javascript:;" class="tab" @click="logout">
            <i class="el-icon-switch-button"></i>
          </a>
        </li>
      </ul>
      <img class="jooyum-logo" src="~@/assets/img/img_logo_p2ps.svg" />

      <p class="company-name">{{ $store.state.companyInfo.company_name }}</p>
    </div>
    <div class="page-sidebar" :class="{ shrink_class: isCollapse }">
      <i
        class="shrink-btn"
        @click="shrinkBtn"
        :class="{ 'shrink-btn-collapse': isCollapse }"
      >
        <i class="el-icon-caret-left" v-if="!isCollapse"></i>
        <i class="el-icon-caret-right" v-if="isCollapse"></i>
      </i>
      <el-menu
        router
        :default-active="$store.state.currentUrl"
        :default-openeds="defaultOpeneds"
        background-color="#2A3239"
        text-color="#989A9B"
        active-text-color="#fff"
        @open="menuOpen"
        @close="menuClose"
        :collapse="isCollapse"
        class="main-menu"
      >
        <!--nav-->
        <el-submenu index="1" v-if="$store.state.isPrivate === 1">
          <template slot="title">
            <i class="icon icon_server"></i>
            <span slot="title">服务器设置</span>
          </template>
          <el-menu-item index="/server-setting/server-ftp-maintenance">
            <router-link to="/server-setting/server-ftp-maintenance"
              >服务器/FTP维护</router-link
            >
          </el-menu-item>
        </el-submenu>
        <el-submenu
          index="2"
          v-if="$store.state.funcModuleArray.includes(1901010000)"
        >
          <template slot="title">
            <i class="icon icon_direct"></i>
            <span slot="title">直连插件管理</span>
          </template>
          <el-menu-item
            index="/direct-manage/direct-dealer-manage"
            v-if="$store.state.funcModuleArray.includes(1901010104)"
          >
            <router-link to="/direct-manage/direct-dealer-manage"
              >直连经销商管理</router-link
            >
          </el-menu-item>
          <el-menu-item
            index="/direct-manage/period-set"
            v-if="$store.state.funcModuleArray.includes(1901010200)"
          >
            <router-link to="/direct-manage/period-set">期间设置</router-link>
          </el-menu-item>
          <el-menu-item
            index="/direct-manage/temp-snatch-task"
            v-if="$store.state.funcModuleArray.includes(1901010305)"
          >
            <router-link to="/direct-manage/temp-snatch-task"
              >临时抓取任务</router-link
            >
          </el-menu-item>
          <el-menu-item
            index="/direct-manage/file-split"
            v-if="$store.state.funcModuleArray.includes(1901010405)"
          >
            <router-link to="/direct-manage/file-split">文件拆分</router-link>
          </el-menu-item>
        </el-submenu>
        <el-submenu
          index="3"
          v-if="$store.state.funcModuleArray.includes(1901020000)"
        >
          <template slot="title">
            <i class="icon icon_grasp"></i>
            <span slot="title">网站爬虫管理</span>
          </template>
          <el-menu-item
            index="/web-grasp-manage/direct-web-manage"
            v-if="$store.state.funcModuleArray.includes(1901020102)"
          >
            <router-link to="/web-grasp-manage/direct-web-manage"
              >网站设置</router-link
            >
          </el-menu-item>
          <el-menu-item
            index="/web-grasp-manage/web-period-set/1"
            v-if="$store.state.funcModuleArray.includes(1901020200)"
          >
            <router-link to="/web-grasp-manage/web-period-set/1"
              >网站期间设置</router-link
            >
          </el-menu-item>
          <el-menu-item
            index="/web-grasp-manage/web-period-set/2"
            v-if="$store.state.funcModuleArray.includes(1901020300)"
          >
            <router-link to="/web-grasp-manage/web-period-set/2"
              >接口期间设置</router-link
            >
          </el-menu-item>
          <el-menu-item
            index="/web-grasp-manage/file-split/1"
            v-if="$store.state.funcModuleArray.includes(1901020407)"
          >
            <router-link to="/web-grasp-manage/file-split/1"
              >网站文件拆分</router-link
            >
          </el-menu-item>
          <el-menu-item
            index="/web-grasp-manage/file-split/3"
            v-if="$store.state.funcModuleArray.includes(1901020507)"
          >
            <router-link to="/web-grasp-manage/file-split/3"
              >接口文件拆分</router-link
            >
          </el-menu-item>
          <el-menu-item
            index="/web-grasp-manage/Initialization-data"
            v-if="$store.state.funcModuleArray.includes(1901020602)"
          >
            <router-link to="/web-grasp-manage/Initialization-data"
              >初始化数据</router-link
            >
          </el-menu-item>
          <el-menu-item
            index="/web-grasp-manage/history_reriod_month"
            v-if="$store.state.funcModuleArray.includes(1901020703)"
          >
            <router-link to="/web-grasp-manage/history_reriod_month"
              >历史月数据采集</router-link
            >
          </el-menu-item>
          <el-menu-item
            index="/web-grasp-manage/multi-account-website/index"
            v-if="$store.state.funcModuleArray.includes(1901020802)"
          >
            <router-link to="/web-grasp-manage/multi-account-website/index"
              >多账号网站</router-link
            >
          </el-menu-item>
        </el-submenu>
        <el-submenu
          index="7"
          v-if="$store.state.funcModuleArray.includes(1901030000)"
        >
          <template slot="title">
            <i class="el-icon-message" style="text-align: left"></i>
            <span slot="title">邮件抓取管理</span>
          </template>
          <el-menu-item
            index="/mail-fetching/business-mapping"
            style="position: relative"
          >
            <router-link to="/mail-fetching/business-mapping"
              >商业映射管理</router-link
            >
            <i class="nav-tag" v-if="totalCount > 0">{{ totalCount }}</i>
          </el-menu-item>
        </el-submenu>
        <el-submenu
          index="8"
          v-if="$store.state.funcModuleArray.includes(1901040000)"
        >
          <template slot="title">
            <i class="icon icon_ftp"></i>
            <span slot="title">FTP抓取管理</span>
          </template>
          <el-menu-item
            index="/ftpCapture/FileSplit"
            v-if="$store.state.funcModuleArray.includes(1901040105)"
          >
            <router-link to="/ftpCapture/FileSplit">文件拆分</router-link>
          </el-menu-item>
        </el-submenu>
        <el-submenu
          index="4"
          v-if="$store.state.funcModuleArray.includes(1901050000)"
        >
          <template slot="title">
            <i class="icon icon_monitor"></i>
            <span slot="title">监控管理</span>
          </template>
          <el-menu-item
            index="/monitoring-manage/plug-in-monitoring"
            v-if="$store.state.funcModuleArray.includes(1901050105)"
          >
            <router-link to="/monitoring-manage/plug-in-monitoring"
              >直连插件监控器</router-link
            >
          </el-menu-item>
          <el-menu-item
            v-if="$store.state.funcModuleArray.includes(1901050202)"
            index="/monitoring-manage/web-period-monitoring"
          >
            <router-link to="/monitoring-manage/web-period-monitoring"
              >网站抓取监控</router-link
            >
          </el-menu-item>
          <el-menu-item
            index="/monitoring-manage/new-web-period-monitoring"
            v-if="$store.state.funcModuleArray.includes(1901050302)"
          >
            <router-link to="/monitoring-manage/new-web-period-monitoring"
              >网站抓取监控（新）</router-link
            >
          </el-menu-item>
          <el-menu-item
            index="/monitoring-manage/mail-fetching-manage"
            v-if="$store.state.funcModuleArray.includes(1901050400)"
          >
            <router-link to="/monitoring-manage/mail-fetching-manage"
              >邮件监控</router-link
            >
          </el-menu-item>
        </el-submenu>
        <el-submenu
          index="5"
          v-if="
            $store.state.companyInfo.company_code &&
              // ['zy', 'jooyum'].indexOf(
              //   $store.state.companyInfo.company_code
              // ) === -1 &&
              $store.state.funcModuleArray.includes(1901060000)
          "
        >
          <template slot="title">
            <i class="icon icon_original"></i>
            <span slot="title">原始文件管理</span>
          </template>
          <el-menu-item
            index="/original-file/up-file-inquire/1"
            v-if="$store.state.funcModuleArray.includes(1901060100)"
          >
            <router-link to="/original-file/up-file-inquire/1"
              >直连文件查询</router-link
            >
          </el-menu-item>
          <el-menu-item
            index="/original-file/web-scrap"
            v-if="$store.state.funcModuleArray.includes(1901060200)"
          >
            <router-link to="/original-file/web-scrap"
              >网抓文件查询</router-link
            >
          </el-menu-item>
          <el-menu-item
            index="/original-file/web-scrap-store"
            v-if="$store.state.funcModuleArray.includes(1901060300)"
          >
            <router-link to="/original-file/web-scrap-store"
              >网抓门店文件查询</router-link
            >
          </el-menu-item>
        </el-submenu>
        <el-submenu
          index="6"
          v-if="$store.state.funcModuleArray.includes(1901070000)"
        >
          <template slot="title">
            <i class="icon icon_install"></i>
            <span slot="title">系统设置</span>
          </template>
          <el-menu-item
            index="/ddiManage/system-set"
            v-if="$store.state.funcModuleArray.includes(1901070100)"
          >
            <router-link to="/ddiManage/system-set">系统设置</router-link>
          </el-menu-item>
          <el-menu-item
            index="/system-set/operation-log"
            v-if="$store.state.funcModuleArray.includes(1901070202)"
          >
            <router-link to="/system-set/operation-log">操作日志</router-link>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
    <div class="page-main" :class="{ main_shrink_class: isCollapse }">
      <div class="page-content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { companyLogout, getCompanyInfo, emailConnectList } from "@/api/index";
export default {
  name: "home",
  components: {},
  data() {
    return {
      isCollapse: false,
      defaultOpeneds: ["1", "2", "3", "4", "5", "6"],
      totalCount: 0
    };
  },
  created() {
    console.log(this.$route, "123333");
    getCompanyInfo().then(res => {
      if (0 === res.status) {
        this.$store.commit("setCompanyInfo", res.data);
        this.$store.commit(
          "setFuncModuleArray",
          res.data.navigation.funcModuleArray || []
        );

        let query = this.$route.query;
        if (query.company_id) {
          let company_id = res.data.company_id;
          if (company_id == query.company_id) {
            if (query.collect_type == 2) {
              this.$router.push({
                name: "directManageNewTask"
              });
            } else {
              this.$router.push({
                name: "webGraspManageInitializationData",
                query: {
                  collect_type: query.collect_type
                }
              });
            }

            // webGraspManageInitializationData
          } else {
            this.$message.error("请登陆该企业的企业流连宝");
          }
        }
      }
    });
    this.getEmailConnectList();
  },
  methods: {
    menuOpen(e) {
      if (this.defaultOpeneds.indexOf(e) === -1) {
        this.defaultOpeneds.push(e);
      }
    },
    menuClose(e) {
      this.defaultOpeneds = this.defaultOpeneds.filter(item => item !== e);
    },
    shrinkBtn() {
      this.isCollapse = !this.isCollapse;
    },
    logout() {
      companyLogout().then(res => {
        if (0 === res.status) {
          this.$router.push({ name: "login" });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getEmailConnectList() {
      /*emailConnectList(2,1).then(res=>{
          if(res.status == 0){
            this.loading = false;
            if (0 === res.status) {
              this.totalCount = res.data.totalCount;
            }
          }
        });*/
    }
  }
};
</script>
<style lang="scss" scoped>
$pageHeader-height: 56px;
$pageHeader-backgroundColor: #1d5bbf;
$pageSidebar-width: 228px;
$pageSidebar-backgroundColor: #2a3239;
.home {
  position: relative;
  width: 100%;
  height: 100%;
  background: #f5f9fa;

  .page-head {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: $pageHeader-height;
    line-height: $pageHeader-height;
    vertical-align: middle;
    background: $pageHeader-backgroundColor;
    color: #fff;
    z-index: 100;

    .logo-container {
      display: inline-block;
      width: $pageSidebar-width;
      height: 100%;
      vertical-align: middle;

      img {
        margin: 5px auto;
        display: block;
      }
    }

    .txt {
      display: inline-block;
      height: 100%;
      vertical-align: middle;
      font-weight: 300;
    }

    .func-list {
      float: right;
      height: 100%;

      li {
        height: 100%;
        float: left;

        .tab {
          display: block;
          padding: 0 18px;
          color: #fff;
          text-decoration: none;

          &:hover {
            background: hsla(0, 0%, 100%, 0.025);
          }
        }
      }
    }
  }

  .page-sidebar {
    position: absolute;
    left: 0;
    top: 0;
    padding: $pageHeader-height 0 6px 0;
    width: $pageSidebar-width;
    height: 100%;
    background: $pageSidebar-backgroundColor;
    z-index: 10;
    transition: width 0.3s;
    overflow: auto;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
  }

  .page-sidebar::-webkit-scrollbar {
    display: none;
  }

  .page-main {
    position: absolute;
    left: 0;
    top: 0;
    padding: $pageHeader-height 0 0 $pageSidebar-width;
    width: 100%;
    height: 100%;
    transition: padding 0.6s;

    .page-content {
      position: relative;
      padding: 16px 24px;
      width: 100%;
      height: 100%;
      overflow: auto;
    }
  }
}

.shrink-btn {
  background: #1e232a;
  color: #999999;
  width: 20px;
  height: 40px;
  position: absolute;
  top: 50%;
  left: calc(#{$pageSidebar-width} - 20px);
  border-radius: 25px 0 0 25px;
  margin-top: -25px;
  cursor: pointer;
  z-index: 666;
  transition: all 0.3s;

  &.shrink-btn-collapse {
    left: 35px;
  }

  i {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.shrink_class {
  width: 55px !important;
}

.main_shrink_class {
  padding: 56px 0 0 64px !important;
}

.icon {
  margin-right: 15px;
  width: 20px;
  height: 17px;
  display: inline-block;
}

.icon_server {
  background: url("~@/assets/img/icon_backstage.svg");
  background-repeat: no-repeat;
}

.icon_direct {
  background: url("~@/assets/img/icon_direct.svg");
  background-repeat: no-repeat;
}

.icon_grasp {
  background: url("~@/assets/img/icon_grasp.svg");
  background-repeat: no-repeat;
}

.icon_monitor {
  background: url("~@/assets/img/icon_monitor.svg");
  background-repeat: no-repeat;
}

.icon_original {
  background: url("~@/assets/img/icon_original.svg");
  background-repeat: no-repeat;
}
.icon_ftp {
  background: url("~@/assets/img/icon_ftp.svg");
  background-repeat: no-repeat;
}
.icon_install {
  background: url("~@/assets/img/icon_install.svg");
  background-repeat: no-repeat;
}
.company-name {
  float: right;
}

.jooyum-logo {
  /*height: 100%;*/
  float: right;
  vertical-align: middle;
}
.nav-tag {
  font-size: 12px;
  position: absolute;
  display: inline-block;
  width: 20px;
  height: 20px;
  background: red;
  border-radius: 50%;
  color: #fff;
  right: 60px;
  top: 15px;
  text-align: center;
  line-height: 20px;
  font-style: normal;
}
</style>
